import React from 'react';
import Button from './Button';
import { useNavigation } from '@react-navigation/native';

const RegisterPrevButton = ({onPress}: {onPress?: Function}) => {
  const navigation = useNavigation();

  return (
    <Button
      variant="outline"
      py="4"
      onPress={() => onPress ? onPress() :  navigation.goBack()}
      flex={1}
      mr={2}>
      Previous
    </Button>
  );
};

export default RegisterPrevButton;
